import { render } from "./FavoritesModal.vue?vue&type=template&id=115b8130"
import script from "./FavoritesModal.vue?vue&type=script&lang=js"
export * from "./FavoritesModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__